import { ArticleFromDom } from '../Integrations/ProductActionsIntegrations/Types';
import { CartItemPayload, VoucherWithDynamicPriceCartPayloadItem, VoucherCartPayloadItem } from './Cart/Types';
import { AccountOnlineAnalysis, AccountSkinAnalysis } from './MyLom/Account/EditAccount/Types';
import { VoucherFromDom } from './Cart/Components/Voucher/VoucherActions';

export const clearDomContainer = (domContainer: HTMLElement) => {
    while (domContainer.firstChild) {
        domContainer.removeChild(domContainer.firstChild);
    }
};

export const formatDate = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return [day, month, year].join('.');
};

export const formatDateRange = (date: Date, date2: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    const year2 = date2.getFullYear();
    const month2 = String(date2.getMonth() + 1).padStart(2, '0');
    const day2 = String(date2.getDate()).padStart(2, '0');

    if (month == month2 && year == year2) {
        return day + '.-' + day2 + '.' + month + '.' + year;
    } else if (year == year2) {
        return day + '.' + month + '.-' + day2 + '.' + month2 + '.' + year;
    } else {
        return [day, month, year].join('.') + '-' + [day2, month2, year2].join('.');
    }
};

export function getParameterByName(name: string, url?: string) {
    if (!url) {
        url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export const isSkinAnalysis = (
    analysis: AccountSkinAnalysis | AccountOnlineAnalysis,
): analysis is AccountSkinAnalysis => analysis.hasOwnProperty('consultant');

export const isOnlineAnalysis = (
    analysis: AccountOnlineAnalysis | AccountSkinAnalysis,
): analysis is AccountOnlineAnalysis => analysis.hasOwnProperty('answers') && analysis.hasOwnProperty('id');

export const isVoucherWithDynamicPrice = (
    item: CartItemPayload | VoucherWithDynamicPriceCartPayloadItem,
): item is VoucherWithDynamicPriceCartPayloadItem => item.type === 'voucherWithDynamicPrice';

export const isVoucher = (article: ArticleFromDom): article is VoucherFromDom =>
    article.type === 'voucherWithDynamicPrice' || article.type === 'voucher';

export const isVoucherPayload = (
    item: CartItemPayload,
): item is VoucherCartPayloadItem | VoucherWithDynamicPriceCartPayloadItem =>
    item.type === 'voucherWithDynamicPrice' || item.type === 'voucher';

export function assertUnreachable(x: never): void {}

export function removeOptionalParamsFromReactRoute(route: string) {
    return route.replace(/\/:(.*)\?/, '');
}

declare global {
    interface Window {
        __GGIsConsultantAsCustomerSession: boolean | undefined;
    }
}
export function isConsultantAsCustomerSession(): boolean {
    return window.__GGIsConsultantAsCustomerSession === true;
}

export function groupBy<T, S>(values: T[], key: (a: T) => S): T[][] {
    const tmp = new Map<S, T[]>();
    for (const value of values) {
        if (tmp.has(key(value))) {
            tmp.get(key(value))?.push(value);
        } else {
            tmp.set(key(value), [value]);
        }
    }
    return [...tmp.values()];
}
